import { QueryCache, QueryClient } from '@tanstack/react-query';

// Centralized so a persister (e.g. @tanstack/query-sync-storage-persister) can be
// added later by wrapping this one export, without touching call sites.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(`Error fetching query ${JSON.stringify(query.queryKey)}:`, error);
    },
  }),
});
